import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { api } from "@tripian/core";
import { PageLoading } from "@tripian/react";
import {
  TRIPS,
  LOGIN,
  SOCIAL_LOGIN_REDIRECT,
  TRIP_CLONE,
  TRIP_PLAN, TIMELINE_PLAN,
} from "../../constants/ROUTER_PATH_TITLE";
import Model from "@tripian/model";
import useAuth from "../../hooks/useAuth";
import useUser from "../../hooks/useUser";
import useTrip from "../../hooks/useTrip";
import { saveLocalStorageToken } from "../../App/AppWrapper/localStorages";
import useTimelineTrip from "../../hooks/useTimelineTrip";

const SocialLoginRedirect = () => {
  const { loggedIn } = useAuth();
  const { userFetch } = useUser();
  const { tripAdd } = useTrip();
  const { timelineTripAdd} = useTimelineTrip();

  const navigate = useNavigate();

  const useQuery = <T extends { [K in keyof T]?: string } = {}>(): T => {
    const query = new URLSearchParams(useLocation().search);
    const result: T = {} as T;
    query.forEach((val, key) => {
      result[key] = val;
    });

    return result;
  };

  const { state } = useQuery<{ state: string | undefined }>();

  useEffect(() => {
    const callbackSuccessLogin = async (token: Model.Token) => {
      saveLocalStorageToken(token);
      loggedIn();
      await userFetch(true);

      window.tconfig.SOCIAL_LOGIN = true;
    };

    const params = new URLSearchParams(window.location.search);
    const queryCode = params.get("code");
    if (queryCode === null) navigate(LOGIN.PATH, { replace: true });
    else {
      api
        .loginCognito(
          queryCode,
          `${window.tconfig.DOMAIN_ORIGIN}${window.tconfig.DOMAIN_ROUTER_BASE_NAME}${SOCIAL_LOGIN_REDIRECT.PATH}`,
          {
            deviceId: "1234",
            serviceToken: "1234",
            deviceOs: "MACOS",
            osVersion: "13",
            bundleId: "asd",
          }
        )
        .then(async (newToken: Model.Token) => {
          api.setToken(newToken);
          await callbackSuccessLogin(newToken);

          // localStorage'dan pending trip profile'ı kontrol et
          const pendingTripProfileStr = localStorage.getItem('pendingTripProfile');
          if (pendingTripProfileStr) {
            try {
              const pendingTripProfile = JSON.parse(pendingTripProfileStr);
              // localStorage'ı temizle
              localStorage.removeItem('pendingTripProfile');

              if (window.tconfig.LANDING_PAGE === "ValaiLanding") {

                // Update only available segments with form data (booking segments stay unchanged)
                const updatedSegments = pendingTripProfile.segments.map(segment => {
                  if (segment.available) {
                    return {
                      ...segment,
                      answerIds: pendingTripProfile.answerIds,
                      adults: pendingTripProfile.adults,
                      children: pendingTripProfile.children,
                    };
                  }
                  // Booking segment (available: false) stays unchanged
                  return segment;
                });

                const finalTripProfile: Model.TimelineTripProfile = {
                  ...pendingTripProfile,
                  segments: updatedSegments,
                };

                const trip = await timelineTripAdd(finalTripProfile);
                navigate(`${TIMELINE_PLAN.PATH}/${trip.tripHash}/0`);
              }else{
                // Trip oluştur
                const trip = await tripAdd(pendingTripProfile);
                navigate(`${TRIP_PLAN.PATH}/${trip.tripHash}/0`, { replace: true });
                return;
              }

            } catch (error) {
              console.error("Trip creation error after social login:", error);
              // Hata durumunda localStorage'ı temizle ve normal akışa devam et
              localStorage.removeItem('pendingTripProfile');
            }
          }

          // console.log("state", state);
          if (state !== undefined && state !== null && state !== "") {
            if (window.tconfig.WIDGET_THEME_1) {
              navigate(`${TRIP_PLAN.PATH}/${state}!s/0`, { replace: true });
            } else {
              navigate(`${TRIP_CLONE.PATH}/${state}`, { replace: true });
            }
          } else {
            navigate(TRIPS.PATH, { replace: true });
          }
        })
        .catch(() => {
          navigate(LOGIN.PATH, { replace: true });
        });
    }
  }, [navigate, loggedIn, userFetch, state, tripAdd]);

  return <PageLoading />;
};

export default SocialLoginRedirect;
